import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// react-snap prerenders this page to static HTML. Hydrate that markup instead
// of createRoot+render: render() discards the prerendered DOM and repaints from
// scratch once the JS bundle finishes loading, which is what was pushing LCP
// past 12s on mobile. hasChildNodes() falls back to a plain client render in
// local dev, where public/index.html's #root is empty.
const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
